import { inject, Injectable, InjectionToken } from '@angular/core';
import { DateServiceInterface } from '@shared/services/date/date.service.interface';

export const DATE_SERVICE_PROVIDER = new InjectionToken<DateServiceInterface>(
  'date-service-provider',
);
@Injectable({
  providedIn: 'root',
})
export class DateService implements DateServiceInterface {
  impl: DateServiceInterface = inject(DATE_SERVICE_PROVIDER);
  getCurrentDate(): string {
    return this.impl.getCurrentDate();
  }

  addDays(date: string, days: number): string {
    return this.impl.addDays(date, days);
  }

  formatDate(date: string, from: string, to: string): string {
    return this.impl.formatDate(date, from, to);
  }

  isValid(date: string, format: string): boolean {
    return this.impl.isValid(date, format);
  }

  getDiffInDays(start: string, end: string): number {
    return this.impl.getDiffInDays(start, end);
  }

  addMonths(date: string, months: number): string {
    return this.impl.addMonths(date, months);
  }

  addMonthFromDate(date: number, month: number): string {
    return this.impl.addMonthFromDate(date, month);
  }

  addYears(date: string, years: number): string {
    return this.impl.addYears(date, years);
  }

  isBefore(start: string, end: string): boolean {
    return this.impl.isBefore(start, end);
  }
}
